import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import "react-vertical-timeline-component/style.min.css";
import * as S from "./styles";
import dayjs from "dayjs";
import { Pagination } from "../../Atoms/Pagination";
import { useHistoryModifySchedule } from "./useHistoryModifySchedule";

export const HistoryModifySchedule = () => {
  const { events, isMobile, pagination, setNumberPage } =
    useHistoryModifySchedule();
  return (
    <>
      <S.WrapperTimeLine>
        <VerticalTimeline
          animate={false}
          layout="1-column-left"
          lineColor="#9D9D9D"
        >
          {events?.length > 0 &&
            events?.map((event, index) => (
              <VerticalTimelineElement
                className="vertical-timeline-element--work"
                contentStyle={{
                  background: index % 2 === 0 ? "#E8E8E8" : "#F7F7F7",
                  borderRadius: "10px",
                  boxShadow: "none",
                  height: "fit-content",
                  display: "flex",
                }}
                contentArrowStyle={{
                  borderRight: `10px solid ${
                    index % 2 === 0 ? "#E8E8E8" : "#F7F7F7"
                  }`,
                }}
                iconStyle={{
                  background: "#9D9D9D",
                  width: "12px",
                  height: "12px",
                  left: "14px",
                  top: "16px",
                  boxShadow: "none",
                }}
              >
                <S.TimeLineContent>
                  <span>{`${dayjs(event?.createdAt).format("DD/MM/YYYY - HH:mm")}`}</span>
                  <p>{event?.descricao || "---"}</p>
                </S.TimeLineContent>
              </VerticalTimelineElement>
            ))}
        </VerticalTimeline>
      </S.WrapperTimeLine>

      {events?.length > 0 && (
        <S.WrapperPagination>
          <Pagination
            maxPageNumbersDisplayed={isMobile ? 3 : 10}
            key={`${Math.random()} - ${pagination}`}
            totalPage={pagination?.totalPage}
            totalRegister={pagination?.totalPage}
            actualPage={pagination?.actualPage}
            setNumberPage={setNumberPage}
          />
        </S.WrapperPagination>
      )}
    </>
  );
};
